import React from "react"; 
import { Button } from "primereact/button";

interface SearchBoxProps {
  query: string;
  setQuery: (q: string) => void;
  onSearch?: (query: string) => void;
}

const SearchBox: React.FC<SearchBoxProps> = ({ query, setQuery, onSearch }) => {

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (onSearch) onSearch(query);
  };

  return (
    <form className="search-box" onSubmit={handleSubmit}>
      <div className="search-input-wrapper">
        <i className="pi pi-search search-icon" />
        <input
          type="text"
          placeholder="Search colleagues by name, skills, department, or expertise..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>
      <Button type="submit">Search</Button>
    </form>
  );
};

export default SearchBox;